

import BestSellingCourseContainer from 'modules/Discover/containers/BestSellingCourseContainer/BestSellingCourseContainer';

type Props = {}

const BestSellingCourse = (props: Props) => {
    return (
        <BestSellingCourseContainer />
    )
}

export default BestSellingCourse;